(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/init.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/init.js');
'use strict';

const {
  ArenaApp
} = svs.arena;
svs.arena.init = () => {
  ReactDOM.render( React.createElement(ArenaApp, null), document.getElementById('react-container'));
};
svs.arena.init();

 })(window);